// src/MainApp.js
// Main router component - shows landing page for web, game for Electron
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './landingpage';
import GameApp from './App';
import DownloadPage from './DownloadPage';

// Detect if we're running in Electron
const isElectron = window.electronAPI !== undefined;

export default function MainApp() {
  // If we're in Electron, just show the game directly (no routing needed)
  if (isElectron) {
    return <GameApp />;
  }

  // For web version, show the full landing page with routing
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/game" element={<GameApp />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}
